// import userSlice from "./userSlice"
// import storage from 'redux-persist/lib/storage'
// import { configureStore } from "@reduxjs/toolkit";
// import permissionsReducer from "./permissionsSlice";
// import propertyReducer from "./propertySlice"; 
// import { persistStore, persistReducer } from 'redux-persist'

// const persistConfig = {
//   key: 'hostelerp-auth',
//   storage,
// }

// const persistedUserReducer = persistReducer(persistConfig, userSlice);

// export const store = configureStore({
//   reducer: {
//     permissions: permissionsReducer,
//     user: persistedUserReducer,
//     property: propertyReducer,
//   },
// });

// export const persistor = persistStore(store);

// redux/store.js
import userSlice from "./userSlice";
import storage from 'redux-persist/lib/storage'
import { configureStore } from "@reduxjs/toolkit";
import permissionsReducer from "./permissionsSlice";
import propertyReducer from "./propertySlice"; 
import recentlyVisitedReducer from "./recentlyVisitedSlice";
import { persistStore, persistReducer } from 'redux-persist'

const persistConfig = {
  key: 'hostelerp-auth',
  storage,
}

const persistedUserReducer = persistReducer(persistConfig, userSlice);

export const store = configureStore({
  reducer: {
    permissions: permissionsReducer,
    user: persistedUserReducer,
    property: propertyReducer,
    recentlyVisited: recentlyVisitedReducer,
  },
});

export const persistor = persistStore(store);